import clsx from "clsx";
import { ReactNode } from "react";
import { useState } from "react";
import EyeFill from "../Icons/EyeFill";
import EyeFillInvisible from "../Icons/EyeFillInvisible";
import UploadIcon from "../Icons/UploadIcon";
import CalendarIcon from "../Icons/CalendarIcon";
export type inputProps = {
  title?: string;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  name: string;
  isControlled?: boolean;
  isRequired?: boolean;
  children?: ReactNode;
  value?: string;
  type?: string;
  step?: string;
  inputStyles?: string;
  error?: string;
  isCode?: boolean;
  upload?: boolean;
  date?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ref?: any;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
};

const Input = ({
  title,
  className,
  placeholder,
  name,
  disabled = false,
  isControlled = true,
  onChange,
  onBlur,
  children,
  value,
  type,
  step,
  error,
  date = false,
  inputStyles,
  isCode,
  upload = false,
  ref,
}: inputProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const isPassword = type === "password" ? true : false;
  const styles = clsx(
    "block h-14 w-full rounded-xl border border-[#d8e0df] bg-[#f8faf9] px-4 py-3 text-sm font-medium text-textPrimary placeholder:text-lightGray/70 transition-all duration-200 hover:border-secondary/50 focus:border-secondary focus:bg-white focus:outline-none focus:ring-4 focus:ring-secondary/10 sm:text-base",
    error ? "border-red-600 focus:border-red-600 focus:ring-red-600/10" : "",
    disabled ? "opacity-50" : ""
  );
  return (
    <div
      className={`relative space-y-1.5 font-medium md:space-y-2 ${className}`}
    >
      {title && (
        <label htmlFor={name} className="text-sm font-semibold text-textPrimary md:text-base">
          {title}
        </label>
      )}
      {isControlled ? (
        <div className="relative">
          <div className="absolute right-4 top-1/2 z-10 -translate-y-1/2 text-lightGray">
            {date && <CalendarIcon />}
            {upload && <UploadIcon height={30} width={30} />}
            {isPassword && (
              <i
                onClick={disabled ? undefined : handleShowPassword}
                className={`input_group__container__icon  ${
                  disabled ? "input_group__container__icon--disabled" : ""
                }`}
              >
                {showPassword ? <EyeFill /> : <EyeFillInvisible />}
              </i>
            )}

            {children}
          </div>
          <input
            type={
              isPassword && showPassword
                ? "text"
                : isPassword
                ? "password"
                : type
            }
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            ref={ref}
            className={`${styles} ${inputStyles}`}
            placeholder={placeholder}
            disabled={disabled}
            name={name}
            aria-invalid={!!error}
            min={0}
            step={step}
            maxLength={isCode ? 1 : undefined}
          />
        </div>
      ) : (
        <div className="relative">
          <div className="absolute right-4 top-1/2 z-10 -translate-y-1/2 text-lightGray">
            {children}
          </div>
          <input
            className={styles}
            placeholder={placeholder}
            disabled={disabled}
            aria-invalid={!!error}
          />
        </div>
      )}
      {error && (
        <span
          className={`text-xs font-semibold text-red-600 sm:text-sm ${
            isCode
              ? "text-[10px] absolute left-1/2 w-full -translate-x-1/2"
              : ""
          } `}
        >
          {error}
        </span>
      )}
    </div>
  );
};

export default Input;
